"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden
 */
var DropClue = /** @class */ (function (_super) {
    __extends(DropClue, _super);
    function DropClue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: 0,
            visible: false,
            left: 0,
            top: 0
        };
        return _this;
    }
    DropClue.prototype.render = function () {
        return this.state.visible && (React.createElement("div", { className: "k-grouping-dropclue", style: {
                zIndex: 10000,
                display: 'block',
                top: this.state.top + 'px',
                left: this.state.left + 'px',
                height: this.state.height + 'px'
            } }));
    };
    return DropClue;
}(React.PureComponent));
exports.DropClue = DropClue;
//# sourceMappingURL=DropClue.js.map